import styled from 'styled-components'

import { minmedia, maxmedia } from '../../styles/media-queries'
import { bordergray, white, darkblue, almostblack } from '../../styles/colors'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;

  ${maxmedia.medium`
    overflow-y: scroll;
    background: ${white};
    padding: 1.5rem;
  `}
  ${minmedia.medium`
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding: 2rem;
  `};
`

export const Popup = styled.div`
  ${minmedia.medium`
    width: 97%;
    max-width: 1200px;
    max-height: 100%;
    overflow: auto; // scrollable if popup is too tall
    border-radius: 0.25rem;
    background: ${white};
    border: 1px solid ${bordergray};
    box-shadow: 0px 1px 8px 3px rgba(0, 0, 0, 0.2);
    padding: 2rem;
  `};
`

export const Close = styled.div`
  transition: color 0.5s;
  margin-top: 1.5rem;
  display: inline;
  float: right;
  font-size: 18px;
  color: ${darkblue};
  cursor: pointer;
  &:hover {
    color: ${almostblack};
  }

  ${maxmedia.medium`
    display: none;
  `}
`

export const MobileClose = styled.div`
  padding: .75rem;
  margin: -1.5rem;
  margin-bottom: 1.5rem;
  width: calc(100% + 3rem);

  font-size: 18px;
  color: ${almostblack};
  cursor: pointer;
  border-bottom: 1px solid ${bordergray};
  line-height: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  &:hover {
    color: ${almostblack};
  }

  svg {
    width: 1rem;
    height: 1rem;
    margin-right: .5rem;
  }

  ${minmedia.medium`
    display: none;
  `}
`



// WEBPACK FOOTER //
// ./src/components/BranchPopup/styles.js